// extracted by mini-css-extract-plugin
export default {"container":"CompensationDialog_container__vcrbK"};